module.exports = __webpack_public_path__ + "img/p7-p1-chuan.f9cbf594.png";